// External Dependencies:
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

// Internal Dependencies:
import isEqual from 'utilities/isEqual'

class Select extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			value: props.value
		}

		this.uid = uuidv4()
	}

	componentDidUpdate( prevProps ) {
		const { id, options, onChange } = this.props

		if ( options && prevProps.options && ! isEqual( options, prevProps.options ) ) {
			const newValue = options[0] ? options[0].value : ''

			this.setState( {
				value: newValue
			} )

			onChange( id, newValue )
		}
	}

	handleChange = ( e ) => {
		this.setState( {
			value: e.target.value
		} )

		this.props.onChange( this.props.id, e.target.value )
	}

	render() {
		const { id, label, value, required, options, uncontrolled, note } = this.props
		let theValue = value || ''

		if ( uncontrolled ) {
			theValue = undefined
		}

		let optionsMarkup = ''

		if ( ! options || ! options.length ) {
			return null
		}

		optionsMarkup = options.map( ( e ) => {
			return (
				<option key={ e.value } value={ e.value }>{ e.name }</option>
			)
		} )

		let className = 'form-item form-select-dropdown'

		if ( ! optionsMarkup.length > 0 ) {
			className += ' is-disabled'
		}

		return (
			<div className={ className }>
				{ label &&
					<label htmlFor={ this.uid }>
						<span dangerouslySetInnerHTML={ { __html: label } } />

						{ required &&
							<span className="-required"> *</span>
						}
					</label>
				}

				<div className="form-select-dropdown-inner">
					<select id={ this.uid } name={ id } onChange={ this.handleChange } value={ theValue } required={ required }>
						{ optionsMarkup }
					</select>
				</div>

				{ note &&
					<div className="form-item-note" dangerouslySetInnerHTML={ { __html: note } } />
				}
			</div>
		)
	}
}

export default Select
